import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiantPointages = {
  state: {
    pointages: [],
    pointage: null,
    totalHoraire: null,
  },
  mutations: {
    setPointages(state, pointages) {
      state.pointages = pointages;
    },
    setPointage(state, pointage) {
      state.pointage = pointage;
    },
    setTotalHoraire(state, horaires){
      state.totalHoraire = horaires;
    }
  },
  actions: {
    fetchPointagesByAbsenceId(context, uri_absence) {
      return ApiService.getRequest(`pointages_light?absence=${uri_absence}`).then(
        response => {
          context.commit('setPointages', response.data['hydra:member'])
          return response.data['hydra:member'];
        }
      ).catch(error => { console.error(error) });
    },
    // Récupération du pointage
    fetchPointagesEtudiant(context, data){
      return ApiService.getRequest('/pointage_occurences_etudiant/', {start: data.start, end: data.end, etudiant_id: data.etudiant_id}).then(
        response => {
          context.commit('setPointages', response.data);
        }
      ).catch(error => { console.error(error) });
    },
    //Récupere les pointage en fonction de l'émargement et de le bénéficiaire
    fetchPointageByEtudiantEmargement(context, data){
      return ApiService.getRequest("/pointages_light", {emargement: data.emargement, etudiant: data.etudiant}).then(
        response => {
          context.commit('setPointage', response.data["hydra:member"])
          return response.data['hydra:member'];
        }
      ).catch(error => { console.error(error) });
    },
    fetchTotalHeuresPresence(context, data){
      return ApiService.getRequest("stagiaire_pointages", data).then(
        response => {
          context.commit('setTotalHoraire', response.data)
          return response.data;
        }
      )
    },
    async fetchTauxPresence(context){
      try{
        const response = await ApiService.getRequest('/get_taux_presence')
        context.commit("setPointages", response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "une erreur s'est produite lors de ma récupération des présences",
          color: 'red',
        })
      }
    },
    //Ajoute une présence à un pointage
    async addEtudiantPointagePresence({state}, data){
      try {
        const response = ApiService.postRequest('/etudiant_pointage_add_presence', data);
        if (response) {
          Notify.create({
            message: "Le pointage a été créée avec succès.",
            color: "green"
          });
          return Promise.resolve();
        }

      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    //Ajout pointage pour quand le bénéficiaire est en stage/entreprise
    async addEtudiantPointageStage({state}, data){
      try {
        const response = ApiService.postRequest('etudiant_pointage_add_stage', data);
        if (response) {
          Notify.create({
            message: "Le pointage a été créée avec succès.",
            color: "green"
          });
          return Promise.resolve();
        }

      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },

    //  ajout d'une absence à un pointage
    async addEtudiantPointageAbsence({ state, dispatch }, data) {
      try {
        const etudiant = await dispatch('fecthEtudiant', data.etudiant_id);
        if (
          (
            etudiant.date_sortie !== null &&
            etudiant.date_sortie !== undefined
          ) ||
          (
            etudiant.date_sortie_prevue !== null &&
            etudiant.date_sortie_prevue !== undefined
          )
        ) {
          const response = ApiService.postRequest('/etudiant_pointage_add_absence', data.form);
          if (response) {
            Notify.create({
              message: "L'absence a été créée avec succès.",
              color: "green"
            });
            return Promise.resolve();
          }
        }
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    //Ajoute une absence à un pointage après avoir crée l'absence dans etudiant_absences
    async addAbsencePointage(context, formData){
      try{
        await ApiService.postRequest('/etudiant_pointage_add_absence', formData);
        Notify.create({
          message: "L'abcence à été ajoutée au pointage",
          color: 'green'
        })
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        });
      }
    },

    /*Modifie le pointage pour le passage en sortie d'un stagiaire + rupture d'un contrat*/
    async updatePointageStop(context, data){
      try{
        const response = await ApiService.patchRequest(data.url, data.datas);
        context.commit("setPointage", response.data);

        Notify.create({
          message: "Mise à jour du pointage du bénéficiaire !",
          color: 'green'
        })
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite lors de la modificatin du pointage",
          color: 'red'
        })
      }
    },

    // Modifie le pointage si une évaluation en alternance est modifier ou si un émargement est modifier,
    // ou si une absence est enregistrer sur une période en entreprise.
    async updatePointage(context, data){
      try{
        await ApiService.postRequest(`update_etudiant_pointage/${data.pointageId}`, data);
        Notify.create({
          message: "Le pointage à été modifié avec succès",
          color: 'green'
        })
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        });
      }
    },
    async updatePointageAbsence(context, data){
      try{
        await ApiService.postRequest(`etudiant_pointage_absence/${data.pointage_id}`, data);
        Notify.create({
          message: "Le pointage à été modifier avec succès",
          color: "green"
        })
      }catch(error){
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },

    deleteEtudiantPointageAbsence({ state }, formData) {
      try {
        ApiService.postRequest('/etudiant_pointage_delete_absence', formData);
        Notify.create({
          message: "La suppression du pointage a été effectuée avec succès.",
          color: "green"
        });
        return Promise.resolve();
      } catch (error) {
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    },
    deleteEtudiantPointage(context, idPointage){
      try{
        ApiService.deleteRequest(`etudiant_pointages/${idPointage}`);
        // context.commit("callbackDeletePointage", idPointage);
        Notify.create({
          message: "La suppression du pointage a été effectuée avec succès.",
          color: "green"
        });
        return Promise.resolve();
      }catch(error){
        console.error(error)
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        return Promise.reject(error);
      }
    }
  },
  getters: {
    getPointages(state) {
      return state.pointages;
    },
    getPointage(state) {
      return state.pointage;
    },
    getTotalHoraire(state){
      return state.totalHoraire;
    }
  }
}
